import React from "react";
import ArticleCard from "../blogs/ArticleCard";

export default function PostCard(props) {
  return (
    <ArticleCard blog={props.blog} className="col-md-6 col-lg-3 col-sm-12 d-flex" />
  );
}
